import React from "react";
import View from "./Components/View";


function ContactUs() {
    return(
     <>
     <View name="Connect With Us"/>
 
     </>
    );
}

export default ContactUs;